import PropTypes from "prop-types"

import InvestmentTransactionReportShape from "./InvestmentTransactionReportShape"

const properties = {
  distributionsAmount: PropTypes.number.isRequired,
  equityReceivedAmount: PropTypes.number.isRequired,
  investmentTransactionReports: PropTypes.arrayOf(InvestmentTransactionReportShape),
  projectId: PropTypes.string.isRequired
}

const ProjectTransactionReportShape = PropTypes.exact(properties)

export default ProjectTransactionReportShape
export { properties }
